module.exports = __webpack_public_path__ + "static/media/powerbi-logo.4e3450ee.svg";